import { render } from "./TopicModal.vue?vue&type=template&id=3c76b45a&scoped=true"
import script from "./TopicModal.vue?vue&type=script&lang=js"
export * from "./TopicModal.vue?vue&type=script&lang=js"

import "./TopicModal.vue?vue&type=style&index=0&id=3c76b45a&lang=stylus&scoped=true"
import "./TopicModal.vue?vue&type=style&index=1&id=3c76b45a&lang=stylus"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c76b45a"]])

export default __exports__